import physical_LE_switch_640 from '../img/purchase/physical_LE_switch_640.jpg';
import physical_LE_switch_640_webp from '../img/purchase/physical_LE_switch_640.webp';
import physical_LE_switch_1280 from '../img/purchase/physical_LE_switch_1280.jpg';
import physical_LE_switch_1280_webp from '../img/purchase/physical_LE_switch_1280.webp';

import physical_SE_switch_640 from '../img/purchase/physical_SE_switch_640.png';
import physical_SE_switch_640_webp from '../img/purchase/physical_SE_switch_640.webp';
import physical_SE_switch_1280 from '../img/purchase/physical_SE_switch_1280.png';
import physical_SE_switch_1280_webp from '../img/purchase/physical_SE_switch_1280.webp';

import physical_SE_switch2_640 from '../img/purchase/physical_SE_switch2_640.png';
import physical_SE_switch2_640_webp from '../img/purchase/physical_SE_switch2_640.webp';
import physical_SE_switch2_1280 from '../img/purchase/physical_SE_switch2_1280.png';
import physical_SE_switch2_1280_webp from '../img/purchase/physical_SE_switch2_1280.webp';

import physical_SE_ps5_640 from '../img/purchase/physical_SE_ps5_640.png';
import physical_SE_ps5_640_webp from '../img/purchase/physical_SE_ps5_640.webp';
import physical_SE_ps5_1280 from '../img/purchase/physical_SE_ps5_1280.png';
import physical_SE_ps5_1280_webp from '../img/purchase/physical_SE_ps5_1280.webp';

import digital_640 from '../img/purchase/digital_640.jpg';
import digital_640_webp from '../img/purchase/digital_640.webp';
import digital_1280 from '../img/purchase/digital_1280.jpg';
import digital_1280_webp from '../img/purchase/digital_1280.webp';

import digital_switch2_640 from '../img/purchase/digital_switch2_640.jpg';
import digital_switch2_640_webp from '../img/purchase/digital_switch2_640.webp';
import digital_switch2_1280 from '../img/purchase/digital_switch2_1280.jpg';
import digital_switch2_1280_webp from '../img/purchase/digital_switch2_1280.webp';

import upgrade_640 from '../img/purchase/upgrade_640.jpg';
import upgrade_640_webp from '../img/purchase/upgrade_640.webp';
import upgrade_1280 from '../img/purchase/upgrade_1280.jpg';
import upgrade_1280_webp from '../img/purchase/upgrade_1280.webp';

import logo from '../img/hero/hero_logo.png';

const purchaseImageList = [
  logo,
  physical_LE_switch_640,
  physical_LE_switch_640_webp,
  physical_LE_switch_1280,
  physical_LE_switch_1280_webp,

  physical_SE_switch_640,
  physical_SE_switch_640_webp,
  physical_SE_switch_1280,
  physical_SE_switch_1280_webp,

  physical_SE_switch2_640,
  physical_SE_switch2_640_webp,
  physical_SE_switch2_1280,
  physical_SE_switch2_1280_webp,

  physical_SE_ps5_640,
  physical_SE_ps5_640_webp,
  physical_SE_ps5_1280,
  physical_SE_ps5_1280_webp,

  digital_640,
  digital_640_webp,
  digital_1280,
  digital_1280_webp,

  digital_switch2_640,
  digital_switch2_640_webp,
  digital_switch2_1280,
  digital_switch2_1280_webp,

  upgrade_640,
  upgrade_640_webp,
  upgrade_1280,
  upgrade_1280_webp,
];

document.addEventListener('DOMContentLoaded', function () {
  const imageCache = {};

  function preloadImages() {
    const preloadContainerId = 'preload-container';

    // Create the container if it doesn't exist
    let container = document.getElementById(preloadContainerId);

    if (!container) {
      container = document.createElement('div');
      container.id = preloadContainerId;
      container.classList.add('visually-hidden');
      document.body.appendChild(container);
    } else {
      container.innerHTML = '';
    }

    purchaseImageList.forEach(src => {
      const img = new Image();
      img.src = src;
      img.onload = () => {
        imageCache[src] = img;

        // Clone and insert into hidden DOM to guarantee caching
        const domImg = document.createElement('img');
        domImg.src = src;
        container?.appendChild(domImg);
      };
      img.onerror = error => {
        console.error(`Failed to load image: ${src}`, error);
      };
    });
  }
  preloadImages();
});

export const countryList = [
  {
    country_name: 'United States of America',
    country_id: 'usa',
    country_cookie: 'en',
  },
  {
    country_name: 'Canada',
    country_id: 'ca',
    country_cookie: 'ca',
  },
];

// NOTE: edition_id MUST include digital or physical in it.
export const editionsList = {
  en: [
    {
      edition_name: 'Physical "Earth Dancer" Limited Edition',
      edition_id: 'physicalLimited',
    },
    {
      edition_name: 'Physical Standard Edition',
      edition_id: 'physicalStandard',
    },
    {
      edition_name: 'Digital Standard Edition',
      edition_id: 'digitalStandard',
    },
    {
      edition_name: 'Digital Deluxe Edition',
      edition_id: 'digitalDeluxe',
    },
    {
      edition_name: 'Super Digital Deluxe Edition',
      edition_id: 'digitalSuperDeluxe',
    },
    {
      edition_name: 'Digital Deluxe DLC Set',
      edition_id: 'digitalDeluxeDLC',
    },
    {
      edition_name: 'Super Digital Deluxe DLC Set',
      edition_id: 'digitalSuperDeluxeDLC',
    },
    {
      edition_name: 'Upgrade Pack',
      edition_id: 'digitalUpgrade',
    },
  ],
  ca: [
    {
      edition_name: 'Physical "Earth Dancer" Limited Edition',
      edition_id: 'physicalLimited',
    },
    {
      edition_name: 'Physical Standard Edition',
      edition_id: 'physicalStandard',
    },
    {
      edition_name: 'Digital Standard Edition',
      edition_id: 'digitalStandard',
    },
    {
      edition_name: 'Digital Deluxe Edition',
      edition_id: 'digitalDeluxe',
    },
    {
      edition_name: 'Super Digital Deluxe Edition',
      edition_id: 'digitalSuperDeluxe',
    },
    {
      edition_name: 'Digital Deluxe DLC Set',
      edition_id: 'digitalDeluxeDLC',
    },
    {
      edition_name: 'Super Digital Deluxe DLC Set',
      edition_id: 'digitalSuperDeluxeDLC',
    },
    {
      edition_name: 'Upgrade Pack',
      edition_id: 'digitalUpgrade',
    },
  ],
};

export const platformsList = [
  {
    platform_name: 'Nintendo Switch',
    platform_id: 'switch',
    platform_cookie: 'switch',
    digitalOnly: false,
    limitedEdition: true,
    digitalDeluxe: true,
    digitalUpgrade: true,
    digitalDLC: true,
  },
  {
    platform_name: 'Nintendo Switch 2',
    platform_id: 'switch2',
    platform_cookie: 'switch2',
    digitalOnly: false,
    limitedEdition: false,
    digitalDeluxe: false,
    digitalUpgrade: true,
    digitalDLC: true,
  },
  {
    platform_name: 'PlayStation 5®',
    platform_id: 'ps5',
    platform_cookie: 'ps5',
    digitalOnly: false,
    limitedEdition: false,
    digitalDeluxe: true,
    digitalUpgrade: false,
    digitalDLC: false,
  },
  {
    platform_name: 'Xbox Series X|S',
    platform_id: 'xbox',
    platform_cookie: 'xbox',
    digitalOnly: true,
    limitedEdition: false,
    digitalDeluxe: true,
    digitalUpgrade: false,
    digitalDLC: false,
  },
  {
    platform_name: 'Steam',
    platform_id: 'steam',
    platform_cookie: 'steam',
    digitalOnly: true,
    limitedEdition: false,
    digitalDeluxe: true,
    digitalUpgrade: false,
    digitalDLC: true,
  },
];

export const purchaseLinks = {
  en: {
    switch2: {
      digital: {
        digitalStandard: {
          name: 'Nintendo eShop',
          link: 'https://nintendo.com/us/store/products/rune-factory-guardians-of-azuma-nintendo-switch-2-edition-switch-2/',
        },
        // digitalDeluxe: {
        //   name: 'Nintendo eShop',
        //   link: '',
        // },
        // digitalSuperDeluxe: {
        //   name: 'Nintendo eShop',
        //   link: '',
        // },
        digitalDeluxeDLC: {
          name: 'Nintendo eShop',
          link: 'https://www.nintendo.com/us/store/products/digital-deluxe-dlc-set-70070000028097-switch/',
        },
        digitalSuperDeluxeDLC: {
          name: 'Nintendo eShop',
          link: 'https://www.nintendo.com/us/store/products/super-digital-deluxe-dlc-set-70070000028098-switch/',
        },
        digitalUpgrade: {
          name: 'Nintendo eShop',
          link: 'https://www.nintendo.com/us/store/products/rune-factory-guardians-of-azuma-nintendo-switch-2-edition-upgrade-pack-switch-2/',
        },
      },
      physical: {
        physicalLimited: [],
        physicalStandard: [
          {
            name: 'Marvelous USA Store',
            link: 'https://marvelous-usa.com/product/rune-factory-guardians-of-azuma/',
          },
          {
            name: 'Best Buy',
            link: 'https://www.bestbuy.com/site/rune-factory-guardians-of-azuma-nintendo-switch-2/6628382.p?skuId=6628382',
          },
          {
            name: 'Amazon',
            link: 'https://www.amazon.com/Factory-Gaurdians-Standard-Nintendo-Switch-2/dp/B0F3KMTVYQ/ref=sr_1_1?crid=19VTOJAJ0L8CR&dib=eyJ2IjoiMSJ9.A7ulMoVYl-qcO0aSW5lm5OquYk0K7I3-9GLbENI-Fs_LHnI_iG41MNqGC9gnO2hY.bqBtG4bfG-O6mPl9abXDulNRtWRfYKpSm9fG8h32dpM&dib_tag=se&keywords=rune+factory+guardians+of+azuma+nintendo+switch+2&qid=1744235297&sprefix=rune+factory+guardians+of+azuma%2Caps%2C172&sr=8-1',
          },
          {
            name: 'Gamestop',
            link: 'https://www.gamestop.com/video-games/nintendo-switch-2/products/rune-factory-guardians-of-azuma---nintendo-switch-2/424981.html',
          },
          {
            name: 'Target',
            link: 'https://www.target.com/p/rune-factory-guardians-of-azuma-nintendo-switch-2/-/A-94711025#lnk=sametab',
          },
          {
            name: 'Walmart',
            link: 'https://www.walmart.com/ip/Rune-Factory-Guardians-of-Azuma-Nintendo-Switch-2/15991910803?classType=REGULAR&athbdg=L1600&from=/search',
          },
        ],
      },
    },
    switch: {
      digital: {
        digitalStandard: {
          name: 'Nintendo eShop',
          link: 'https://nintendo.com/us/store/products/rune-factory-guardians-of-azuma-switch/',
        },
        digitalDeluxe: {
          name: 'Nintendo eShop',
          link: 'https://nintendo.com/us/store/products/rune-factory-guardians-of-azuma-digital-deluxe-edition-switch/',
        },
        digitalSuperDeluxe: {
          name: 'Nintendo eShop',
          link: 'https://nintendo.com/us/store/products/rune-factory-guardians-of-azuma-super-digital-deluxe-edition-switch/',
        },
        digitalDeluxeDLC: {
          name: 'Nintendo eShop',
          link: 'https://www.nintendo.com/us/store/products/digital-deluxe-dlc-set-70070000028097-switch/',
        },
        digitalSuperDeluxeDLC: {
          name: 'Nintendo eShop',
          link: 'https://www.nintendo.com/us/store/products/super-digital-deluxe-dlc-set-70070000028098-switch/',
        },
        digitalUpgrade: {
          name: 'Nintendo eShop',
          link: 'https://www.nintendo.com/us/store/products/rune-factory-guardians-of-azuma-nintendo-switch-2-edition-upgrade-pack-switch-2/',
        },
      },
      physical: {
        physicalLimited: [
          {
            name: 'Marvelous USA Store',
            link: 'https://marvelous-usa.com/product/rune-factory-guardians-of-azuma/',
          },
          {
            name: 'Best Buy',
            link: 'https://www.bestbuy.com/site/rune-factory-guardians-of-azuma-earth-dancer-limited-edition-nintendo-switch/6599240.p?skuId=6599240',
          },
          {
            name: 'GameStop',
            link: 'https://www.gamestop.com/video-games/nintendo-switch/products/rune-factory-guardians-of-azuma---earth-dancer-limited-edition---nintendo-switch/415499.html',
          },
          {
            name: 'Amazon',
            link: 'https://www.amazon.com/Rune-Factory-Guardians-Dancer-Limited-Nintendo/dp/B0DFDVXDG5/ref=sr_1_1?crid=2AIJ47V750VZ9&dib=eyJ2IjoiMSJ9.NrtbI6_LtEuJIbEeQELtT4H7wNDIvk0BziTs60s0Vf7GjHj071QN20LucGBJIEps.2EObypeoo5NAr9gAzZgQAAbtzNPE4tjVj0Moah8z5ks&dib_tag=se&keywords=azuma+rune+factory&qid=1725033610&sprefix=%2Caps%2C157&sr=8-1',
          },
          {
            name: 'Target',
            link: 'http://target.com/p/rune-factory-guardians-of-azuma-earth-dancer-limited-edition-nintendo-switch/-/A-93537121',
          },
          {
            name: 'Walmart',
            link: 'https://www.walmart.com/ip/Rune-Factory-Guardians-of-Azuma-Earth-Dancer-Limited-Edition-Nintendo-Switch/10690714208?classType=REGULAR&from=/search',
          },
        ],
        physicalStandard: [
          {
            name: 'Marvelous USA Store',
            link: 'https://marvelous-usa.com/product/rune-factory-guardians-of-azuma/',
          },
          {
            name: 'Best Buy',
            link: 'https://www.bestbuy.com/site/rune-factory-guardians-of-azuma-nintendo-switch/6599238.p?skuId=6599238',
          },
          {
            name: 'GameStop',
            link: 'https://www.gamestop.com/video-games/nintendo-switch/products/rune-factory-guardians-of-azuma---nintendo-switch/415497.html',
          },
          {
            name: 'Amazon',
            link: 'https://www.amazon.com/Rune-Factory-Guardians-Azuma-Nintendo-Switch/dp/B0DFDX7CBH/ref=sr_1_2?crid=2AIJ47V750VZ9&dib=eyJ2IjoiMSJ9.NrtbI6_LtEuJIbEeQELtT4H7wNDIvk0BziTs60s0Vf7GjHj071QN20LucGBJIEps.2EObypeoo5NAr9gAzZgQAAbtzNPE4tjVj0Moah8z5ks&dib_tag=se&keywords=azuma+rune+factory&qid=1725034689&sprefix=%2Caps%2C157&sr=8-2',
          },
          {
            name: 'Target',
            link: 'https://www.target.com/p/rune-factory-guardians-of-azuma-nintendo-switch/-/A-93537110',
          },
          {
            name: 'Walmart',
            link: 'https://www.walmart.com/ip/Rune-Factory-Guardians-of-Azuma-Nintendo-Switch/10691358960?classType=REGULAR&from=/search',
          },
        ],
      },
    },
    steam: {
      digital: {
        digitalStandard: {
          name: 'steam',
          link: 'https://store.steampowered.com/app/2864560/Rune_Factory_Guardians_of_Azuma/',
        },
        digitalDeluxe: {
          name: 'steam',
          link: 'https://store.steampowered.com/sub/1317058/',
        },
        digitalSuperDeluxe: {
          name: 'steam',
          link: 'https://store.steampowered.com/sub/1317059/',
        },
        digitalDeluxeDLC: {
          name: 'steam',
          link: 'https://store.steampowered.com/app/3717920/Rune_Factory_Guardians_of_Azuma__Digital_Deluxe_DLC_Set/',
        },
        digitalSuperDeluxeDLC: {
          name: 'steam',
          link: 'https://store.steampowered.com/app/3717930/Rune_Factory_Guardians_of_Azuma__Super_Digital_Deluxe_DLC_Set/',
        },
      },
    },
    ps5: {
      digital: {
        digitalStandard: {
          name: 'PlayStation Store',
          link: 'https://store.playstation.com/en-us/concept/10010244',
        },
        digitalDeluxe: {
          name: 'PlayStation Store',
          link: 'https://store.playstation.com/en-us/concept/10010244',
        },
        digitalSuperDeluxe: {
          name: 'PlayStation Store',
          link: 'https://store.playstation.com/en-us/concept/10010244',
        },
        digitalDeluxeDLC: {
          name: 'PlayStation Store',
          link: 'https://store.playstation.com/en-us/concept/10010244',
        },
        digitalSuperDeluxeDLC: {
          name: 'PlayStation Store',
          link: 'https://store.playstation.com/en-us/concept/10010244',
        },
        digitalUpgrade: {
          name: 'PlayStation Store',
          link: 'https://store.playstation.com/en-us/concept/10010244',
        },
      },
      physical: {
        physicalLimited: [],
        physicalStandard: [
          {
            name: 'Amazon',
            link: 'http://amazon.com/Rune-Factory-Guardians-AMAZON-EXCLUSIVE-PlayStation/dp/B0G4SPT4BJ/ref=sr_1_3?crid=3DC7AX68K5RL3&dib=eyJ2IjoiMSJ9.okL8aRiTfBIUtcmpXTEdXQppUhG3Njw-nEw-3a2e2JLHeH2Rl4l22vqNc8JK9WvwU3in7Lu7NEmwxWBhXQjj_boX8Fd6NYnKS3YtsFzWF8wtO7Ec4nLH5WSytdy2P69I_jAH5RYa7zI20MYzSFM2vWiHyPB9uzAWG58NfPSRHkUV7HqAINiGIEzPcy5YHvaQeKCinIKJzZEGCW8tc83A-g.XAlq2iMb7W0RcLdVaoRsnFrMV9aNPz2CvNaZUb7KrMs&dib_tag=se&keywords=guardians+of+azuma&qid=1765242163&s=videogames&sprefix=guardians+of+azum%2Cvideogames%2C138&sr=1-3',
          },
        ],
      },
    },
    xbox: {
      digital: {
        digitalStandard: {
          name: 'Microsoft Store',
          link: 'https://www.xbox.com/en-US/games/store/rune-factory-guardians-of-azuma/9P9NKXJ79V0C',
        },
        digitalDeluxe: {
          name: 'Microsoft Store',
          link: 'https://www.xbox.com/en-US/games/store/rune-factory-guardians-of-azuma/9P9NKXJ79V0C',
        },
        digitalSuperDeluxe: {
          name: 'Microsoft Store',
          link: 'https://www.xbox.com/en-US/games/store/rune-factory-guardians-of-azuma/9P9NKXJ79V0C',
        },
        digitalDeluxeDLC: {
          name: 'Microsoft Store',
          link: 'https://www.xbox.com/en-US/games/store/rune-factory-guardians-of-azuma/9P9NKXJ79V0C',
        },
        digitalSuperDeluxeDLC: {
          name: 'Microsoft Store',
          link: 'https://www.xbox.com/en-US/games/store/rune-factory-guardians-of-azuma/9P9NKXJ79V0C',
        },
        digitalUpgrade: {
          name: 'Microsoft Store',
          link: 'https://www.xbox.com/en-US/games/store/rune-factory-guardians-of-azuma/9P9NKXJ79V0C',
        },
      },
      physical: {
        physicalLimited: [],
        physicalStandard: [
          // {
          //   name: 'Amazon',
          //   link: 'https://www.amazon.com/Factory-Gaurdians-Standard-Nintendo-Switch-2/dp/B0F3KMTVYQ/ref=sr_1_1?crid=19VTOJAJ0L8CR&dib=eyJ2IjoiMSJ9.A7ulMoVYl-qcO0aSW5lm5OquYk0K7I3-9GLbENI-Fs_LHnI_iG41MNqGC9gnO2hY.bqBtG4bfG-O6mPl9abXDulNRtWRfYKpSm9fG8h32dpM&dib_tag=se&keywords=rune+factory+guardians+of+azuma+nintendo+switch+2&qid=1744235297&sprefix=rune+factory+guardians+of+azuma%2Caps%2C172&sr=8-1',
          // },
        ],
      },
    },
  },
  ca: {
    switch2: {
      digital: {
        digitalStandard: {
          name: 'Nintendo eShop',
          link: 'https://nintendo.com/en-ca/store/products/rune-factory-guardians-of-azuma-nintendo-switch-2-edition-switch-2/',
        },
        // digitalDeluxe: {
        //   name: 'Nintendo eShop',
        //   link: '',
        // },
        // digitalSuperDeluxe: {
        //   name: 'Nintendo eShop',
        //   link: '',
        // },
        digitalDeluxeDLC: {
          name: 'Nintendo eShop',
          link: 'https://www.nintendo.com/en-ca/store/products/digital-deluxe-dlc-set-70070000028097-switch/',
        },
        digitalSuperDeluxeDLC: {
          name: 'Nintendo eShop',
          link: 'https://www.nintendo.com/en-ca/store/products/super-digital-deluxe-dlc-set-70070000028098-switch/',
        },
        digitalUpgrade: {
          name: 'Nintendo eShop',
          link: 'https://www.nintendo.com/en-ca/store/products/rune-factory-guardians-of-azuma-nintendo-switch-2-edition-upgrade-pack-switch-2/',
        },
      },
      physical: {
        physicalLimited: [],
        physicalStandard: [
          {
            name: 'Amazon.CA',
            link: 'https://www.amazon.ca/Rune-Factory-Guardians-Azuma-Nintendo/dp/B0F3KMTVYQ/ref=sr_1_8?dib=eyJ2IjoiMSJ9.bsKthCr-49bfu9Xcyw1Vf7HgnJREHdOHoJlotn2GbjmKbkNlZqTLLby9M1iIesNjCCdyrGrapHu0VVzLUKik-_mgqnaIkXn5-Nu8pYgZsiXitgpC5zoeHa0_FW-1XdCLGbyZW75HVbbiIxGY224LwiKrWTH4siXOYEMXNXdZlvzm6KVpjTT5y-3bvJg3vdidjTv2F6VM9VbjahLTKpk0DbXKfXKAv5bzHh_6iJJzM7qJ1FvHV2sM17G9MV82ZRnKyD9sI__zVJCXijjrjckoaz29PMebvMnzA1s_pNwji7g.DOM3SoqR_GK0_jNMUrZYLtSjl8Ez5H2M9O4te7RuUY4&dib_tag=se&keywords=Xseed+Games&qid=1746041392&sr=8-8',
          },
          {
            name: 'Gamestop (CA)',
            link: 'https://www.gamestop.ca/Switch%202/Games/936002/rune-factory-guardians-of-azuma',
          },
        ],
      },
    },
    switch: {
      digital: {
        digitalStandard: {
          name: 'Nintendo eShop',
          link: 'https://nintendo.com/en-ca/store/products/rune-factory-guardians-of-azuma-switch/',
        },
        digitalDeluxe: {
          name: 'Nintendo eShop',
          link: 'https://nintendo.com/en-ca/store/products/rune-factory-guardians-of-azuma-digital-deluxe-edition-switch/',
        },
        digitalSuperDeluxe: {
          name: 'Nintendo eShop',
          link: 'https://nintendo.com/en-ca/store/products/rune-factory-guardians-of-azuma-super-digital-deluxe-edition-switch/',
        },
        digitalDeluxeDLC: {
          name: 'Nintendo eShop',
          link: 'https://www.nintendo.com/en-ca/store/products/digital-deluxe-dlc-set-70070000028097-switch/',
        },
        digitalSuperDeluxeDLC: {
          name: 'Nintendo eShop',
          link: 'https://www.nintendo.com/en-ca/store/products/super-digital-deluxe-dlc-set-70070000028098-switch/',
        },
        digitalUpgrade: {
          name: 'Nintendo eShop',
          link: 'https://www.nintendo.com/en-ca/store/products/rune-factory-guardians-of-azuma-nintendo-switch-2-edition-upgrade-pack-switch-2/',
        },
      },
      physical: {
        physicalLimited: [
          // {
          //   name: 'Marvelous-USA Store',
          //   link: '',
          // },
          {
            name: 'GameStop (CA)',
            link: 'https://www.gamestop.ca/Switch/Games/926945/rune-factory-guardians-of-azuma-earth-dancer-limited-edition',
          },
          // {
          //   name: 'VGP.CA',
          //   link: '',
          // },
          // {
          //   name: 'PNP Games Online',
          //   link: '',
          // },
          {
            name: 'Amazon.CA',
            link: 'https://www.amazon.ca/Rune-Factory-Guardians-Limited-Nintendo/dp/B0DFDVXDG5/ref=sr_1_1?crid=AF4CPCIQV22R&dib=eyJ2IjoiMSJ9.8wzTTaSJtXVpUG79CKRYUw_bG05U57Q6mQmDSLZumA5pIXbjexyuwXWLz0ErC0b1ySODkhciv6J3KATqtarZ4m8YJdneCl2a0jAU4ngSLy5JLTMn2Xxu_eOO-2eamFyk1Rh056ytYqjYPGPAAenckw.6StQtwJmHfQb8WZfN1Q8gE6rfldFn4pXIncI_W8l7Kg&dib_tag=se&keywords=rune%2Bfactory%2Bguardians%2Bof%2Bazuma&qid=1743622020&sprefix=guardians%2Bof%2Bazuma%2Caps%2C136&sr=8-1&th=1',
          },
        ],
        physicalStandard: [
          // {
          //   name: 'Marvelous-USA Store',
          //   link: '',
          // },
          {
            name: 'GameStop (CA)',
            link: 'https://www.gamestop.ca/Switch/Games/926944/rune-factory-guardians-of-azuma',
          },
          // {
          //   name: 'VGP.CA',
          //   link: '',
          // },
          // {
          //   name: 'PNP Games Online',
          //   link: '',
          // },
          {
            name: 'Amazon.CA',
            link: 'https://www.amazon.ca/dp/B0DFDX7CBH?_encoding=UTF8&ref=cm_sw_r_cp_ud_dp_Y8F0G8C74RFBNHHR492G&ref_=cm_sw_r_cp_ud_dp_Y8F0G8C74RFBNHHR492G&social_share=cm_sw_r_cp_ud_dp_Y8F0G8C74RFBNHHR492G&th=1',
          },
        ],
      },
    },
    steam: {
      digital: {
        digitalStandard: {
          name: 'steam',
          link: 'https://store.steampowered.com/app/2864560/Rune_Factory_Guardians_of_Azuma/',
        },
        digitalDeluxe: {
          name: 'steam',
          link: 'https://store.steampowered.com/sub/1317058/',
        },
        digitalSuperDeluxe: {
          name: 'steam',
          link: 'https://store.steampowered.com/sub/1317059/',
        },
        digitalDeluxeDLC: {
          name: 'steam',
          link: 'https://store.steampowered.com/app/3717920/Rune_Factory_Guardians_of_Azuma__Digital_Deluxe_DLC_Set/',
        },
        digitalSuperDeluxeDLC: {
          name: 'steam',
          link: 'https://store.steampowered.com/app/3717930/Rune_Factory_Guardians_of_Azuma__Super_Digital_Deluxe_DLC_Set/',
        },
      },
    },
    ps5: {
      digital: {
        digitalStandard: {
          name: 'PlayStation Store',
          link: 'https://store.playstation.com/en-ca/concept/10010244',
        },
        digitalDeluxe: {
          name: 'PlayStation Store',
          link: 'https://store.playstation.com/en-ca/concept/10010244',
        },
        digitalSuperDeluxe: {
          name: 'PlayStation Store',
          link: 'https://store.playstation.com/en-ca/concept/10010244',
        },
        digitalDeluxeDLC: {
          name: 'PlayStation Store',
          link: 'https://store.playstation.com/en-ca/concept/10010244',
        },
        digitalSuperDeluxeDLC: {
          name: 'PlayStation Store',
          link: 'https://store.playstation.com/en-ca/concept/10010244',
        },
        digitalUpgrade: {
          name: 'PlayStation Store',
          link: 'https://store.playstation.com/en-ca/concept/10010244',
        },
      },
      physical: {
        physicalLimited: [],
        physicalStandard: [
          {
            name: 'Amazon',
            link: 'https://www.amazon.ca/Rune-Factory-Guardians-Azuma-Playstation/dp/B0G4SPT4BJ/',
          },
        ],
      },
    },
    xbox: {
      digital: {
        digitalStandard: {
          name: 'Microsoft Store',
          link: 'https://www.xbox.com/en-CA/games/store/rune-factory-guardians-of-azuma/9P9NKXJ79V0C',
        },
        digitalDeluxe: {
          name: 'Microsoft Store',
          link: 'https://www.xbox.com/en-CA/games/store/rune-factory-guardians-of-azuma/9P9NKXJ79V0C',
        },
        digitalSuperDeluxe: {
          name: 'Microsoft Store',
          link: 'https://www.xbox.com/en-CA/games/store/rune-factory-guardians-of-azuma/9P9NKXJ79V0C',
        },
        digitalDeluxeDLC: {
          name: 'Microsoft Store',
          link: 'https://www.xbox.com/en-CA/games/store/rune-factory-guardians-of-azuma/9P9NKXJ79V0C',
        },
        digitalSuperDeluxeDLC: {
          name: 'Microsoft Store',
          link: 'https://www.xbox.com/en-CA/games/store/rune-factory-guardians-of-azuma/9P9NKXJ79V0C',
        },
        digitalUpgrade: {
          name: 'Microsoft Store',
          link: 'https://www.xbox.com/en-CA/games/store/rune-factory-guardians-of-azuma/9P9NKXJ79V0C',
        },
      },
      physical: {
        physicalLimited: [],
        physicalStandard: [
          // {
          //   name: 'Amazon',
          //   link: 'https://www.amazon.com/Factory-Gaurdians-Standard-Nintendo-Switch-2/dp/B0F3KMTVYQ/ref=sr_1_1?crid=19VTOJAJ0L8CR&dib=eyJ2IjoiMSJ9.A7ulMoVYl-qcO0aSW5lm5OquYk0K7I3-9GLbENI-Fs_LHnI_iG41MNqGC9gnO2hY.bqBtG4bfG-O6mPl9abXDulNRtWRfYKpSm9fG8h32dpM&dib_tag=se&keywords=rune+factory+guardians+of+azuma+nintendo+switch+2&qid=1744235297&sprefix=rune+factory+guardians+of+azuma%2Caps%2C172&sr=8-1',
          // },
        ],
      },
    },
  },
};

export const comingSoon = {
  en: 'Links Coming Soon',
  ca: 'Links Coming Soon',
  uk: 'Links Coming Soon',
  au: 'Links Coming Soon',
  fr: 'Liens bientôt disponibles',
  it: 'Collegamenti presto disponibili',
  de: 'Links bald verfügbar',
  es: 'Enlaces muy pronto',
  br: 'Links em breve',
  mx: 'Próximamente los enlaces',
};

export const switchSoon = {
  en: 'Physical Pre-Orders will be Available Soon!',
  ca: 'Links Coming Soon',
  uk: 'Links Coming Soon',
  au: 'Links Coming Soon',
  fr: 'Liens bientôt disponibles',
  it: 'Collegamenti presto disponibili',
  de: 'Links bald verfügbar',
  es: 'Enlaces muy pronto',
  br: 'Links em breve',
  mx: 'Próximamente los enlaces',
};

export const editionsInfo = {
  en: {
    switch2: {
      physicalLimited: {
        image_640: '',
        image_1280: '',
        image_640_webp: '',
        image_1280_webp: '',
        title: '',
        items: [],
      },
      physicalStandard: {
        image_640: physical_SE_switch2_640,
        image_1280: physical_SE_switch2_1280,
        image_640_webp: physical_SE_switch2_640_webp,
        image_1280_webp: physical_SE_switch2_1280_webp,
        title: '',
        items: [],
      },
      digitalStandard: {
        image_640: digital_640,
        image_1280: digital_1280,
        image_640_webp: digital_640_webp,
        image_1280_webp: digital_1280_webp,
        title: '',
        items: [],
      },
      digitalDeluxe: {
        image_640: digital_640,
        image_1280: digital_1280,
        image_640_webp: digital_640_webp,
        image_1280_webp: digital_1280_webp,
        title: '',
        items: [],
      },
      digitalSuperDeluxe: {
        image_640: digital_640,
        image_1280: digital_1280,
        image_640_webp: digital_640_webp,
        image_1280_webp: digital_1280_webp,
        title: '',
        items: [],
      },
      digitalDeluxeDLC: {
        image_640: digital_switch2_640,
        image_1280: digital_switch2_1280,
        image_640_webp: digital_switch2_640_webp,
        image_1280_webp: digital_switch2_1280_webp,
        title: '',
        items: [],
      },
      digitalSuperDeluxeDLC: {
        image_640: digital_switch2_640,
        image_1280: digital_switch2_1280,
        image_640_webp: digital_switch2_640_webp,
        image_1280_webp: digital_switch2_1280_webp,
        title: '',
        items: [],
      },
      digitalUpgrade: {
        image_640: upgrade_640,
        image_1280: upgrade_1280,
        image_640_webp: upgrade_640_webp,
        image_1280_webp: upgrade_1280_webp,
        title: '',
        items: [],
      },
    },
    switch: {
      physicalLimited: {
        image_640: physical_LE_switch_640,
        image_1280: physical_LE_switch_1280,
        image_640_webp: physical_LE_switch_640_webp,
        image_1280_webp: physical_LE_switch_1280_webp,
        title: '',
        items: [],
      },
      physicalStandard: {
        image_640: physical_SE_switch_640,
        image_1280: physical_SE_switch_1280,
        image_640_webp: physical_SE_switch_640_webp,
        image_1280_webp: physical_SE_switch_1280_webp,
        title: '',
        items: [],
      },
      digitalStandard: {
        image_640: digital_640,
        image_1280: digital_1280,
        image_640_webp: digital_640_webp,
        image_1280_webp: digital_1280_webp,
        title: '',
        items: [],
      },
      digitalDeluxe: {
        image_640: digital_640,
        image_1280: digital_1280,
        image_640_webp: digital_640_webp,
        image_1280_webp: digital_1280_webp,
        title: '',
        items: [],
      },
      digitalSuperDeluxe: {
        image_640: digital_640,
        image_1280: digital_1280,
        image_640_webp: digital_640_webp,
        image_1280_webp: digital_1280_webp,
        title: '',
        items: [],
      },
      digitalDeluxeDLC: {
        image_640: digital_switch2_640,
        image_1280: digital_switch2_1280,
        image_640_webp: digital_switch2_640_webp,
        image_1280_webp: digital_switch2_1280_webp,
        title: '',
        items: [],
      },
      digitalSuperDeluxeDLC: {
        image_640: digital_switch2_640,
        image_1280: digital_switch2_1280,
        image_640_webp: digital_switch2_640_webp,
        image_1280_webp: digital_switch2_1280_webp,
        title: '',
        items: [],
      },
      digitalUpgrade: {
        image_640: upgrade_640,
        image_1280: upgrade_1280,
        image_640_webp: upgrade_640_webp,
        image_1280_webp: upgrade_1280_webp,
        title: '',
        items: [],
      },
    },
    ps5: {
      physicalLimited: {
        image_640: '',
        image_1280: '',
        image_640_webp: '',
        image_1280_webp: '',
        title: '',
        items: [],
      },
      physicalStandard: {
        image_640: physical_SE_ps5_640,
        image_1280: physical_SE_ps5_1280,
        image_640_webp: physical_SE_ps5_640_webp,
        image_1280_webp: physical_SE_ps5_1280_webp,
        title: '',
        items: [],
      },
      digitalStandard: {
        image_640: digital_640,
        image_1280: digital_1280,
        image_640_webp: digital_640_webp,
        image_1280_webp: digital_1280_webp,
        title: '',
        items: [],
      },
      digitalDeluxe: {
        image_640: digital_640,
        image_1280: digital_1280,
        image_640_webp: digital_640_webp,
        image_1280_webp: digital_1280_webp,
        title: '',
        items: [],
      },
      digitalSuperDeluxe: {
        image_640: digital_640,
        image_1280: digital_1280,
        image_640_webp: digital_640_webp,
        image_1280_webp: digital_1280_webp,
        title: '',
        items: [],
      },
      digitalDeluxeDLC: {
        image_640: digital_switch2_640,
        image_1280: digital_switch2_1280,
        image_640_webp: digital_switch2_640_webp,
        image_1280_webp: digital_switch2_1280_webp,
        title: '',
        items: [],
      },
      digitalSuperDeluxeDLC: {
        image_640: digital_switch2_640,
        image_1280: digital_switch2_1280,
        image_640_webp: digital_switch2_640_webp,
        image_1280_webp: digital_switch2_1280_webp,
        title: '',
        items: [],
      },
      digitalUpgrade: {
        image_640: upgrade_640,
        image_1280: upgrade_1280,
        image_640_webp: upgrade_640_webp,
        image_1280_webp: upgrade_1280_webp,
        title: '',
        items: [],
      },
    },
    xbox: {
      physicalLimited: {
        image_640: '',
        image_1280: '',
        image_640_webp: '',
        image_1280_webp: '',
        title: '',
        items: [],
      },
      physicalStandard: {
        image_640: '',
        image_1280: '',
        image_640_webp: '',
        image_1280_webp: '',
        title: '',
        items: [],
      },
      digitalStandard: {
        image_640: digital_640,
        image_1280: digital_1280,
        image_640_webp: digital_640_webp,
        image_1280_webp: digital_1280_webp,
        title: '',
        items: [],
      },
      digitalDeluxe: {
        image_640: digital_640,
        image_1280: digital_1280,
        image_640_webp: digital_640_webp,
        image_1280_webp: digital_1280_webp,
        title: '',
        items: [],
      },
      digitalSuperDeluxe: {
        image_640: digital_640,
        image_1280: digital_1280,
        image_640_webp: digital_640_webp,
        image_1280_webp: digital_1280_webp,
        title: '',
        items: [],
      },
      digitalDeluxeDLC: {
        image_640: digital_switch2_640,
        image_1280: digital_switch2_1280,
        image_640_webp: digital_switch2_640_webp,
        image_1280_webp: digital_switch2_1280_webp,
        title: '',
        items: [],
      },
      digitalSuperDeluxeDLC: {
        image_640: digital_switch2_640,
        image_1280: digital_switch2_1280,
        image_640_webp: digital_switch2_640_webp,
        image_1280_webp: digital_switch2_1280_webp,
        title: '',
        items: [],
      },
      digitalUpgrade: {
        image_640: upgrade_640,
        image_1280: upgrade_1280,
        image_640_webp: upgrade_640_webp,
        image_1280_webp: upgrade_1280_webp,
        title: '',
        items: [],
      },
    },
    steam: {
      digitalStandard: {
        image_640: digital_640,
        image_1280: digital_1280,
        image_640_webp: digital_640_webp,
        image_1280_webp: digital_1280_webp,
        title: '',
        items: [],
      },
      digitalDeluxe: {
        image_640: digital_640,
        image_1280: digital_1280,
        image_640_webp: digital_640_webp,
        image_1280_webp: digital_1280_webp,
        title: '',
        items: [],
      },
      digitalSuperDeluxe: {
        image_640: digital_640,
        image_1280: digital_1280,
        image_640_webp: digital_640_webp,
        image_1280_webp: digital_1280_webp,
        title: '',
        items: [],
      },
      digitalDeluxeDLC: {
        image_640: digital_switch2_640,
        image_1280: digital_switch2_1280,
        image_640_webp: digital_switch2_640_webp,
        image_1280_webp: digital_switch2_1280_webp,
        title: '',
        items: [],
      },
      digitalSuperDeluxeDLC: {
        image_640: digital_switch2_640,
        image_1280: digital_switch2_1280,
        image_640_webp: digital_switch2_640_webp,
        image_1280_webp: digital_switch2_1280_webp,
        title: '',
        items: [],
      },
    },
  },
  ca: {
    switch2: {
      physicalStandard: {
        image_640: physical_SE_switch2_640,
        image_1280: physical_SE_switch2_1280,
        image_640_webp: physical_SE_switch2_640_webp,
        image_1280_webp: physical_SE_switch2_1280_webp,
        title: '',
        items: [],
      },
      digitalStandard: {
        image_640: digital_640,
        image_1280: digital_1280,
        image_640_webp: digital_640_webp,
        image_1280_webp: digital_1280_webp,
        title: '',
        items: [],
      },
      digitalDeluxe: {
        image_640: digital_640,
        image_1280: digital_1280,
        image_640_webp: digital_640_webp,
        image_1280_webp: digital_1280_webp,
        title: '',
        items: [],
      },
      digitalSuperDeluxe: {
        image_640: digital_640,
        image_1280: digital_1280,
        image_640_webp: digital_640_webp,
        image_1280_webp: digital_1280_webp,
        title: '',
        items: [],
      },
      digitalDeluxeDLC: {
        image_640: digital_switch2_640,
        image_1280: digital_switch2_1280,
        image_640_webp: digital_switch2_640_webp,
        image_1280_webp: digital_switch2_1280_webp,
        title: '',
        items: [],
      },
      digitalSuperDeluxeDLC: {
        image_640: digital_switch2_640,
        image_1280: digital_switch2_1280,
        image_640_webp: digital_switch2_640_webp,
        image_1280_webp: digital_switch2_1280_webp,
        title: '',
        items: [],
      },
      digitalUpgrade: {
        image_640: upgrade_640,
        image_1280: upgrade_1280,
        image_640_webp: upgrade_640_webp,
        image_1280_webp: upgrade_1280_webp,
        title: '',
        items: [],
      },
    },
    switch: {
      physicalLimited: {
        image_640: physical_LE_switch_640,
        image_1280: physical_LE_switch_1280,
        image_640_webp: physical_LE_switch_640_webp,
        image_1280_webp: physical_LE_switch_1280_webp,
        title: '',
        items: [],
      },
      physicalStandard: {
        image_640: physical_SE_switch_640,
        image_1280: physical_SE_switch_1280,
        image_640_webp: physical_SE_switch_640_webp,
        image_1280_webp: physical_SE_switch_1280_webp,
        title: '',
        items: [],
      },
      digitalStandard: {
        image_640: digital_640,
        image_1280: digital_1280,
        image_640_webp: digital_640_webp,
        image_1280_webp: digital_1280_webp,
        title: '',
        items: [],
      },
      digitalDeluxe: {
        image_640: digital_640,
        image_1280: digital_1280,
        image_640_webp: digital_640_webp,
        image_1280_webp: digital_1280_webp,
        title: '',
        items: [],
      },
      digitalSuperDeluxe: {
        image_640: digital_640,
        image_1280: digital_1280,
        image_640_webp: digital_640_webp,
        image_1280_webp: digital_1280_webp,
        title: '',
        items: [],
      },
      digitalDeluxeDLC: {
        image_640: digital_switch2_640,
        image_1280: digital_switch2_1280,
        image_640_webp: digital_switch2_640_webp,
        image_1280_webp: digital_switch2_1280_webp,
        title: '',
        items: [],
      },
      digitalSuperDeluxeDLC: {
        image_640: digital_switch2_640,
        image_1280: digital_switch2_1280,
        image_640_webp: digital_switch2_640_webp,
        image_1280_webp: digital_switch2_1280_webp,
        title: '',
        items: [],
      },
      digitalUpgrade: {
        image_640: upgrade_640,
        image_1280: upgrade_1280,
        image_640_webp: upgrade_640_webp,
        image_1280_webp: upgrade_1280_webp,
        title: '',
        items: [],
      },
    },
    ps5: {
      physicalLimited: {
        image_640: '',
        image_1280: '',
        image_640_webp: '',
        image_1280_webp: '',
        title: '',
        items: [],
      },
      physicalStandard: {
        image_640: physical_SE_ps5_640,
        image_1280: physical_SE_ps5_1280,
        image_640_webp: physical_SE_ps5_640_webp,
        image_1280_webp: physical_SE_ps5_1280_webp,
        title: '',
        items: [],
      },
      digitalStandard: {
        image_640: digital_640,
        image_1280: digital_1280,
        image_640_webp: digital_640_webp,
        image_1280_webp: digital_1280_webp,
        title: '',
        items: [],
      },
      digitalDeluxe: {
        image_640: digital_640,
        image_1280: digital_1280,
        image_640_webp: digital_640_webp,
        image_1280_webp: digital_1280_webp,
        title: '',
        items: [],
      },
      digitalSuperDeluxe: {
        image_640: digital_640,
        image_1280: digital_1280,
        image_640_webp: digital_640_webp,
        image_1280_webp: digital_1280_webp,
        title: '',
        items: [],
      },
      digitalDeluxeDLC: {
        image_640: digital_switch2_640,
        image_1280: digital_switch2_1280,
        image_640_webp: digital_switch2_640_webp,
        image_1280_webp: digital_switch2_1280_webp,
        title: '',
        items: [],
      },
      digitalSuperDeluxeDLC: {
        image_640: digital_switch2_640,
        image_1280: digital_switch2_1280,
        image_640_webp: digital_switch2_640_webp,
        image_1280_webp: digital_switch2_1280_webp,
        title: '',
        items: [],
      },
      digitalUpgrade: {
        image_640: upgrade_640,
        image_1280: upgrade_1280,
        image_640_webp: upgrade_640_webp,
        image_1280_webp: upgrade_1280_webp,
        title: '',
        items: [],
      },
    },
    xbox: {
      physicalLimited: {
        image_640: '',
        image_1280: '',
        image_640_webp: '',
        image_1280_webp: '',
        title: '',
        items: [],
      },
      physicalStandard: {
        image_640: '',
        image_1280: '',
        image_640_webp: '',
        image_1280_webp: '',
        title: '',
        items: [],
      },
      digitalStandard: {
        image_640: digital_640,
        image_1280: digital_1280,
        image_640_webp: digital_640_webp,
        image_1280_webp: digital_1280_webp,
        title: '',
        items: [],
      },
      digitalDeluxe: {
        image_640: digital_640,
        image_1280: digital_1280,
        image_640_webp: digital_640_webp,
        image_1280_webp: digital_1280_webp,
        title: '',
        items: [],
      },
      digitalSuperDeluxe: {
        image_640: digital_640,
        image_1280: digital_1280,
        image_640_webp: digital_640_webp,
        image_1280_webp: digital_1280_webp,
        title: '',
        items: [],
      },
      digitalDeluxeDLC: {
        image_640: digital_switch2_640,
        image_1280: digital_switch2_1280,
        image_640_webp: digital_switch2_640_webp,
        image_1280_webp: digital_switch2_1280_webp,
        title: '',
        items: [],
      },
      digitalSuperDeluxeDLC: {
        image_640: digital_switch2_640,
        image_1280: digital_switch2_1280,
        image_640_webp: digital_switch2_640_webp,
        image_1280_webp: digital_switch2_1280_webp,
        title: '',
        items: [],
      },
      digitalUpgrade: {
        image_640: upgrade_640,
        image_1280: upgrade_1280,
        image_640_webp: upgrade_640_webp,
        image_1280_webp: upgrade_1280_webp,
        title: '',
        items: [],
      },
    },
    steam: {
      digitalStandard: {
        image_640: digital_640,
        image_1280: digital_1280,
        image_640_webp: digital_640_webp,
        image_1280_webp: digital_1280_webp,
        title: '',
        items: [],
      },
      digitalDeluxe: {
        image_640: digital_640,
        image_1280: digital_1280,
        image_640_webp: digital_640_webp,
        image_1280_webp: digital_1280_webp,
        title: '',
        items: [],
      },
      digitalSuperDeluxe: {
        image_640: digital_640,
        image_1280: digital_1280,
        image_640_webp: digital_640_webp,
        image_1280_webp: digital_1280_webp,
        title: '',
        items: [],
      },
      digitalDeluxeDLC: {
        image_640: digital_640,
        image_1280: digital_1280,
        image_640_webp: digital_640_webp,
        image_1280_webp: digital_1280_webp,
        title: '',
        items: [],
      },
      digitalSuperDeluxeDLC: {
        image_640: digital_640,
        image_1280: digital_1280,
        image_640_webp: digital_640_webp,
        image_1280_webp: digital_1280_webp,
        title: '',
        items: [],
      },
    },
  },
};
